import { render, staticRenderFns } from "./StatsCARatiosFranceMap.vue?vue&type=template&id=5f6afb74&scoped=true"
import script from "./StatsCARatiosFranceMap.vue?vue&type=script&lang=js"
export * from "./StatsCARatiosFranceMap.vue?vue&type=script&lang=js"
import style0 from "./StatsCARatiosFranceMap.vue?vue&type=style&index=0&id=5f6afb74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6afb74",
  null
  
)

export default component.exports